export function HomeSkeleton() {
  return (
    <div className="home-screen">
      <div className="home-skeleton-greeting" />
      <div className="home-skeleton-subtitle" />
      <div className="home-section" style={{ marginTop: 32 }}>
        <div className="home-skeleton-section-title" />
        {[1, 2, 3].map((i) => (
          <div key={i} className="home-skeleton-card">
            <div className="home-skeleton-stripe" />
            <div className="home-skeleton-body">
              <div className="home-skeleton-line home-skeleton-line--title" />
              <div className="home-skeleton-line home-skeleton-line--summary" />
              <div className="home-skeleton-line home-skeleton-line--meta" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
